import { useEffect, useId } from 'react';
import { hasValue } from './mailWriting';

// Paint DOM ranges without changing Quill's document, undo history or email HTML.
export default function useMailFieldHighlights(root, body, values, enabled) {
  const id = useId().replace(/[^a-zA-Z0-9]/g,'');
  const ready = `mail-ready-${id}`, missing = `mail-missing-${id}`;
  useEffect(()=>{
    if(!enabled || !window.CSS?.highlights || !window.Highlight) return;
    const frame = requestAnimationFrame(()=>{
      const editor=root.current?.querySelector('.ql-editor');
      if(!editor)return;
      const walker=document.createTreeWalker(editor,NodeFilter.SHOW_TEXT), nodes=[];
      let text='', node;
      while((node=walker.nextNode())){nodes.push({node,start:text.length,end:text.length+node.textContent.length});text+=node.textContent;}
      const good=[], bad=[];
      for(const match of text.matchAll(/\{\{\s*([a-zA-Z][a-zA-Z0-9_.]{0,511})\s*\}\}/g)){
        const start=nodes.find(n=>n.end>match.index), end=nodes.find(n=>n.end>=match.index+match[0].length);
        if(!start||!end)continue;
        const range=new Range();range.setStart(start.node,match.index-start.start);range.setEnd(end.node,match.index+match[0].length-end.start);
        (hasValue(values[match[1]])?good:bad).push(range);
      }
      window.CSS.highlights.set(ready,new window.Highlight(...good));
      window.CSS.highlights.set(missing,new window.Highlight(...bad));
    });
    return()=>{cancelAnimationFrame(frame);window.CSS.highlights.delete(ready);window.CSS.highlights.delete(missing);};
  },[root,body,values,enabled,ready,missing]);
  return `::highlight(${ready}){background:#dceffc;color:#075780}::highlight(${missing}){background:#fff0d3;color:#89520a;text-decoration:underline wavy #b5751e}`;
}
